module.exports = __webpack_public_path__ + "static/media/adp.b709add2.svg";